import { render, staticRenderFns } from "./editarPerfilView.vue?vue&type=template&id=687eaad5&"
import script from "./editarPerfilView.vue?vue&type=script&lang=ts&"
export * from "./editarPerfilView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports